var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 6.5925H3.99V11.5925C3.99 12.1425 4.44 12.5925 4.99 12.5925H8.99C9.54 12.5925 9.99 12.1425 9.99 11.5925V6.5925H11.58C12.47 6.5925 12.92 5.5125 12.29 4.8825L7.7 0.2925C7.31 -0.0975 6.68 -0.0975 6.29 0.2925L1.7 4.8825C1.07 5.5125 1.51 6.5925 2.4 6.5925ZM0 15.5925C0 16.1425 0.45 16.5925 1 16.5925H13C13.55 16.5925 14 16.1425 14 15.5925C14 15.0425 13.55 14.5925 13 14.5925H1C0.45 14.5925 0 15.0425 0 15.5925Z",
    fill: "#00205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.559a9d3bd655df603d2a368b78016484.svg";
export { ForwardRef as ReactComponent };